import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import DropDownTable from '../../Shared/DropDownTable';
import '../../../css/TruckAppointment/CreateAppointment.css';
import Input from '../../Shared/Input';
import Button from '../../Shared/Button';
import arrowUp from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-up.svg';
import downarrow from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-down.svg';
import hrLine from '../../../Assets/ContainerStatus/Assets_Desktop//horizontal-dotted-line.svg';
import search from '../../../Assets/TruckVisits/Assets-Desktop/search-icon.svg';
import calender from '../../../Assets/TruckVisits/Assets-Desktop/calender.svg';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import ReasonsModal from '../../Shared/ReasonsModal';
import SuccessModal from '../../Shared/SuccessModal';
import Message from '../../../Data/Shared/Message.json';
import ColorCode from '../../../Data/Shared/ColorCode.json'; 
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';

class CreateAppointment extends Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            SelectTerminal: '',
            gatevalue: '',
            transactionvalue: '',
            containervalue: '',
            appointmentvalue: '',
            lineOperator: '',
            truckLicenseNo: '',
            referenceNo: '',
            truckingCompany: '',
            driverLicense: '',
            containerID: '',
            bookingNo: '',
            vesselVisit: '',
            terminaldropdown: false,
            gatedropdown: false,
            transactiondropdown: false,
            containerdropdown: false,
            appointmentdropdown: false,
            lineOperatordropdown: false,
            truckingcompanydropdown: false,
            driverlicensedropdown: false,
            containeriddropdown: false,
            vesselvisitdropdown: false,
            terminal: [],
            gate: [],
            transaction: [],
            containerData: [],
            appointment: [],
            lineOperatordata: [{ name: "dca" }, { name: "abc" }, { name: "bcd" }],
            searchlength: 0,
            lineOperatordataTemporary: [],
            truckingcompanydata: [{ name: "dca" }, { name: "abc" }, { name: "bcd" }],
            searchtrucklength: 0,
            truckingcompanydata1: [],
            driverlicensedata: [{ name: "dca" }, { name: "abc" }, { name: "bcd" }],
            searchdriverlength: 0,
            driverlicensedata1: [],
            containeriddata: [{ name: "dca" }, { name: "abc" }, { name: "bcd" }],
            searchcontainerlength: 0,
            containeriddata1: [],
            vesselvisitdata: [{ name: "dca" }, { name: "abc" }, { name: "bcd" }],
            searchvessellength: 0,
            vesselvisitdata1: [],
            calender: new Date(),
            showCalender: false,
            calendarIndicator: false,
            hasOpenPreview: false,
            hasOpen: false,
            errors: {}
        }
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handlechangelineOperator = this.handlechangelineOperator.bind(this);
        this.handleChangeTruckingCompany = this.handleChangeTruckingCompany.bind(this);
        this.handleChangeDriverLicense = this.handleChangeDriverLicense.bind(this);
        this.handleChangeContainerID = this.handleChangeContainerID.bind(this);
        this.handleChangeVesselVisit = this.handleChangeVesselVisit.bind(this);
    }

    componentDidMount = () => {
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            this.setState({ terminaldropdown: false });
            this.setState({ gatedropdown: false });
            this.setState({ transactiondropdown: false });
            this.setState({ containerdropdown: false });
            this.setState({ appointmentdropdown: false });
            this.setState({ showCalender: false });
            this.setState({ lineOperatordropdown: false });
            this.setState({ truckingcompanydropdown: false });
            this.setState({ drivinglicensedropdown: false });
            this.setState({ containeriddropdown: false });
            this.setState({ vesselvisitdropdown: false });
        }
    };

    terminaldata = [
        { id: 1, terminal: "Cape Town Container Terminal", triptype: "Transhipment" },
        { id: 2, terminal: "Durban Pier One Container Terminal", triptype: "Export" },
        { id: 3, terminal: "Durban Pier One Container Terminal", triptype: "Import" }]

    handlechangelineOperator = (e) => {
        this.setState({
            lineOperator: e.target.value,
            searchlength: e.target.value?.length
        });
        this.setState({
            errors: {
                ...this.state.errors,
                lineOperator: ''
            }
        });
        document.getElementsByName('lineOperator')[0].style.borderColor = ColorCode.colorCode.black;
    };

    terminal = [{ terminalname: "xyz" }, { terminalname: "xyz" }, { terminalname: "xyz" }]
    gate = [{ name: "xyz" }, { name: "xyz" }, { name: "xyz" }]
    transaction = [{ name: "xyz" }, { name: "xyz" }, { name: "xyz" }]
    containerData = [{ name: "xyz" }, { name: "xyz" }, { name: "xyz" }]
    appointment = [{ name: "xyz" }, { name: "xyz" }, { name: "xyz" }]

    toggleDropdownTerminal = () => {
        this.setState({ terminaldropdown: !this.state.terminaldropdown });
    };

    changeRoleTypeTerminal = (event) => {
        const found = this.terminal?.find((name) => {
            if (name.terminalname === event.target.innerText) {
                return name
            }
        })
        this.setState({ SelectTerminal: found.terminalname });
        this.setState({ terminaldropdown: !this.state.terminaldropdown });
        this.setState({
            errors: {
                ...this.state.errors,
                selectTerminal: ''
            }
        });
        document.getElementsByName('SelectTerminal')[0].style.borderColor = ColorCode.colorCode.black;
    }

    toggleDropdowngate = () => {
        this.setState({ gatedropdown: !this.state.gatedropdown });
        console.log('vvv')
    };

    changeRoleTypegate = (event) => {
        const found = this.gate?.find((name) => {
            if (name.name === event.target.innerText) {
                return name
            }
        })
        this.setState({ gatevalue: found.name });
        this.setState({ gatedropdown: !this.state.gatedropdown });
        this.setState({
            errors: {
                ...this.state.errors,
                selectGate: ''
            }
        });
        document.getElementsByName('gatevalue')[0].style.borderColor = ColorCode.colorCode.black;
    }

    toggleDropdowntransaction = () => {
        this.setState({ transactiondropdown: !this.state.transactiondropdown });
        console.log('vvv')
    };

    changeRoleTypetransaction = (event) => {
        const found = this.transaction?.find((name) => {
            if (name.name === event.target.innerText) {
                return name
            }
        })
        this.setState({ transactionvalue: found.name });
        this.setState({ transactiondropdown: !this.state.transactiondropdown });
        this.setState({
            errors: {
                ...this.state.errors,
                transactionType: ''
            }
        });
        document.getElementsByName('transactionvalue')[0].style.borderColor = ColorCode.colorCode.black;
    }

    toggleDropdowncontainer = () => {
        this.setState({ containerdropdown: !this.state.containerdropdown });
        console.log('vvv')
    };

    changeRoleTypecontainer = (event) => {
        const found = this.containerData?.find((name) => {
            if (name.name === event.target.innerText) {
                return name
            }
        })
        this.setState({ containervalue: found.name });
        this.setState({ containerdropdown: !this.state.containerdropdown });
        this.setState({
            errors: {
                ...this.state.errors,
                containerEquipment: ''
            }
        });
        document.getElementsByName('containervalue')[0].style.borderColor = ColorCode.colorCode.black;
    }

    toggleDropdownappointment = () => {
        this.setState({ appointmentdropdown: !this.state.appointmentdropdown });
        console.log('vvv')
    };

    changeRoleTypeappointment = (event) => {
        const found = this.appointment?.find((name) => {
            if (name.name === event.target.innerText) {
                return name
            }
        })
        this.setState({ appointmentvalue: found.name });
        this.setState({ appointmentdropdown: !this.state.appointmentdropdown });
        this.setState({
            errors: {
                ...this.state.errors,
                appointmentOpenings: ''
            }
        });
        document.getElementsByName('appointmentvalue')[0].style.borderColor = ColorCode.colorCode.black;
    }

    toggleMonthCalendar = () => {
        this.setState({ showCalender: !this.showCalender, calendarIndicator: true });
        this.setState({
            errors: {
                ...this.state.errors,
                requestedDate: ''
            }
        });
        document.getElementsByName('requestedDate')[0].style.borderColor = ColorCode.colorCode.black;
    }

    handleMonthChanged = (e) => {
        this.setState({
            calender: e
        });
    }

    handleSubmit = () => {
        if (this.handleValidation()) {
            this.onSubscribe();
        }
    }

    handleValidation() {
        let errors = {};
        let formIsValid = true;
        if (!this.state.SelectTerminal) {
            formIsValid = false;
            errors["selectTerminal"] = Message.validation.required;
            document.getElementsByName('SelectTerminal')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('SelectTerminal')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.gatevalue) {
            formIsValid = false;
            errors["selectGate"] = Message.validation.required;
            document.getElementsByName('gatevalue')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('gatevalue')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.lineOperator) {
            formIsValid = false;
            errors["lineOperator"] = Message.validation.required;
            document.getElementsByName('lineOperator')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('lineOperator')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.transactionvalue) {
            formIsValid = false;
            errors["transactionType"] = Message.validation.required;
            document.getElementsByName('transactionvalue')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('transactionvalue')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.truckingCompany) {
            formIsValid = false;
            errors["truckingCompany"] = Message.validation.required;
            document.getElementsByName('truckingCompany')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('truckingCompany')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.containerID) {
            formIsValid = false;
            errors["containerID"] = Message.validation.required;
            document.getElementsByName('containerID')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('containerID')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.containervalue) {
            formIsValid = false;
            errors["containerEquipment"] = Message.validation.required;
            document.getElementsByName('containervalue')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('containervalue')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.vesselVisit) {
            formIsValid = false;
            errors["vesselVisit"] = Message.validation.required;
            document.getElementsByName('vesselVisit')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('vesselVisit')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (this.state.calendarIndicator == false) {
            formIsValid = false;
            errors["requestedDate"] = Message.validation.required;
            document.getElementsByName('requestedDate')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('requestedDate')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.appointmentvalue) {
            formIsValid = false;
            errors["appointmentOpenings"] = Message.validation.required;
            document.getElementsByName('appointmentvalue')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('appointmentvalue')[0].style.borderColor = ColorCode.colorCode.black;
        }
        this.setState({ errors: errors });
        return formIsValid;
    }

    handleChangeTruckLicenseNo = (e) => {
        this.setState({ truckLicenseNo: e.target.value });
    }

    handleChangeReferenceNo = (e) => {
        this.setState({ referenceNo: e.target.value });
    }

    handleChangeTruckingCompany = (e) => {
        this.setState({ truckingCompany: e.target.value, searchtrucklength: e.target.value?.length });
        this.setState({
            errors: {
                ...this.state.errors,
                truckingCompany: ''
            }
        });
        document.getElementsByName('truckingCompany')[0].style.borderColor = ColorCode.colorCode.black;
    }

    handleChangeDriverLicense = (e) => {
        this.setState({ driverLicense: e.target.value, searchdriverlength: e.target.value?.length });
    }

    handleChangeContainerID = (e) => {
        this.setState({ containerID: e.target.value, searchcontainerlength: e.target.value?.length });
        this.setState({
            errors: {
                ...this.state.errors,
                containerID: ''
            }
        });
        document.getElementsByName('containerID')[0].style.borderColor = ColorCode.colorCode.black;
    }

    handleChangeBookingNo = (e) => {
        this.setState({ bookingNo: e.target.value });
    }

    handleChangeVesselVisit = (e) => {
        this.setState({ vesselVisit: e.target.value, searchvessellength: e.target.value?.length });
        this.setState({
            errors: {
                ...this.state.errors,
                vesselVisit: ''
            }
        });
        document.getElementsByName('vesselVisit')[0].style.borderColor = ColorCode.colorCode.black;
    }

    toggleSearchlineOperatordrop = (e) => {
        this.setState({ lineOperatordropdown: true });
        console.log('vvv');
    };

    toggleSearchtruckingcompanydrop = (e) => {
        this.setState({ truckingcompanydropdown: true });
    };

    toggleSearchdrivinglicensedrop = (e) => {
        this.setState({ drivinglicensedropdown: true });
    };

    toggleSearchcontaineriddrop = (e) => {
        this.setState({ containeriddropdown: true });
    };

    toggleSearchvesselvisitdrop = (e) => {
        this.setState({ vesselvisitdropdown: true });
    };

    changelineOperator = (event) => {
        const found = this.state.lineOperatordataTemporary?.find((name) => {
            if (name.name === event.target.innerText) {
                return name
            }
        })
        this.setState({ lineOperator: found.name });
        this.setState({ lineOperatordropdown: !this.state.lineOperatordropdown });
    }

    changetruckingcompany = (event) => {
        const found = this.state.truckingcompanydata1?.find((name) => {
            if (name.name === event.target.innerText) {
                return name
            }
        })
        this.setState({ truckingCompany: found.name });
        this.setState({ truckingcompanydropdown: !this.state.truckingcompanydropdown });
    }

    changedrivinglicense = (event) => {
        const found = this.state.driverlicensedata1?.find((name) => {
            if (name.name === event.target.innerText) {
                return name
            }
        })
        this.setState({ driverLicense: found.name });
        this.setState({ drivinglicensedropdown: !this.state.drivinglicensedropdown });
    }

    changecontainerid = (event) => {
        const found = this.state.containeriddata1?.find((name) => {
            if (name.name === event.target.innerText) {
                return name
            }
        })
        this.setState({ containerID: found.name });
        this.setState({ containeriddropdown: !this.state.containeriddropdown });
    }

    changevesselvisit = (event) => {
        const found = this.state.vesselvisitdata1?.find((name) => {
            if (name.name === event.target.innerText) {
                return name
            }
        })
        this.setState({ vesselVisit: found.name });
        this.setState({ vesselvisitdropdown: !this.state.vesselvisitdropdown });
    }

    onSubscribe = () => {
        this.setState({ hasOpenPreview: true });
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

    onCloseModalPreveiw = () => {
        this.setState({ hasOpenPreview: false });
    }

    onClickModalPreview = () => {
        this.setState({ hasOpenPreview: false });
        this.props.history.push('/TruckAppointment', {})
    }

    onCloseModal = () => {
        this.setState({ hasOpen: false });
        this.props.history.push('/TruckAppointment', {})
    };

    render() {
        if (this.state.searchlength > 0) {
            this.state.lineOperatordataTemporary = this.state.lineOperatordata?.filter(i => i.name.startsWith(this.state.lineOperator.toLowerCase()))
        } else {
            this.state.lineOperatordataTemporary = [];
        }
        if (this.state.searchtrucklength > 0) {
            this.state.truckingcompanydata1 = this.state.truckingcompanydata?.filter(i => i.name.startsWith(this.state.truckingCompany.toLowerCase()))
        } else {
            this.state.truckingcompanydata1 = [];
        }
        if (this.state.searchdriverlength > 0) {
            this.state.driverlicensedata1 = this.state.driverlicensedata?.filter(i => i.name.startsWith(this.state.driverLicense.toLowerCase()))
        } else {
            this.state.driverlicensedata1 = [];
        }
        if (this.state.searchcontainerlength > 0) {
            this.state.containeriddata1 = this.state.containeriddata?.filter(i => i.name.startsWith(this.state.containerID.toLowerCase()))
        } else {
            this.state.containeriddata1 = [];
        }
        if (this.state.searchvessellength > 0) {
            this.state.vesselvisitdata1 = this.state.vesselvisitdata?.filter(i => i.name.startsWith(this.state.vesselVisit.toLowerCase()))
        } else {
            this.state.vesselvisitdata1 = [];
        }
        let terminalDropdownImage = this.state.terminaldropdown ? <img src={arrowUp} /> : <img src={downarrow} />
        let gatedropdownImage = this.state.gatedropdown ? <img src={arrowUp} /> : <img src={downarrow} />
        let transactiondropdownImage = this.state.transactiondropdown ? <img src={arrowUp} /> : <img src={downarrow} />
        let containerdropdownImage = this.state.containerdropdown ? <img src={arrowUp} /> : <img src={downarrow} />
        let appointmentdropdownImage = this.state.appointmentdropdown ? <img src={arrowUp} /> : <img src={downarrow} />
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        let calendarFormatted_date = this.state.calender.getDate() + "-" + months[this.state.calender.getMonth()] + "-" + this.state.calender.getFullYear();
        if (this.state.calender.getDate() <= 9) {
            calendarFormatted_date = "0" + calendarFormatted_date;
        }
        return (
            <div class="caacsoutercolor">
                <MetaDecorator title={TitleDescription.createAppointmentPageTitle} description={TitleDescription.createAppointmentPageDescription} />
                <Header  tilesFetched = {()=>{}}/>
                <div class="caacsnofullCreateAppoint">
                    <div id="caacsnobox1">
                        <nav class="caacnononavbar">
                            <div className="caacnonavbarname">
                                <small id="nonavc">Create Appointment</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="appcaanotificationmaincard">
                            <div class="caaoncsdivlow1">
                                <div class="adscsdivlow2">
                                    Site Selection</div>
                            </div>
                            <div class="caadivup1">
                                <div class="caadivup2CreateAppointment">
                                    <div class="caadivup3CreateAppointment">
                                        <small id="caaname">Terminal</small>
                                        <div className="pass-wrapper" id="caad07" >
                                            <Input
                                                name="SelectTerminal"
                                                readOnly class="input" value={this.state.SelectTerminal} placeholder="Select Terminal"
                                                type="text" id="caad066"
                                            />
                                            <div className="createappointmenterror1">{this.state.errors["selectTerminal"]}</div>
                                            <i id="caainput_imgAddProfile" onClick={this.toggleDropdownTerminal}>{terminalDropdownImage}</i>                                        </div>
                                        {this.state.terminaldropdown && (
                                            <div class="caaad08" >
                                                <div class="caadropdowncard" ref={this.container} >
                                                    {(this.terminal?.map((name, index) => {
                                                        return (
                                                            <DropDownTable onClick={(index1) => this.changeRoleTypeTerminal(index1)} >
                                                                <small class="pl-3" id="caatt2" >{name?.terminalname} </small>
                                                            </DropDownTable>
                                                        );
                                                    }))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div class="caaoncsdivlow122CreateAppointment">  
                                <div class="adscsdivlow2">
                                    Basics</div>
                            </div>
                            <div class="caadivup1">
                                <div class="caadivup4CreateAppointment">
                                    <div class="caadivup55">
                                        <div class="caadivup3CreateAppointment">
                                            <small id="caaname">Gate / Zone</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="gatevalue"
                                                    readOnly class="input" placeholder="Select Gate / Zone"
                                                    type="text" id="caad066" value={this.state.gatevalue}
                                                />
                                                <div className="createappointmenterror1">{this.state.errors["selectGate"]}</div>
                                                <i id="caainput_imgAddProfile" onClick={this.toggleDropdowngate}>{gatedropdownImage}</i>
                                            </div>
                                            {this.state.gatedropdown && (
                                                <div class="caaad08" >
                                                    <div class="caadropdowncard" ref={this.container} >
                                                        {(this.gate?.map((name, index) => {
                                                            return (
                                                                <DropDownTable onClick={(index1) => this.changeRoleTypegate(index1)} >
                                                                    <small class="pl-3" id="caatt2" >{name?.name} </small>
                                                                </DropDownTable>
                                                            );
                                                        }))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div class="caadivup3CreateAppointment">
                                            <small id="caaname">Line Operator</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="lineOperator"
                                                    class="input" placeholder="Enter Line Operator"
                                                    type="text" id="caad06" value={this.state.lineOperator}
                                                    onChange={this.handlechangelineOperator}
                                                    onKeyPress={this.toggleSearchlineOperatordrop}
                                                />
                                                <div className="createappointmenterror1">{this.state.errors["lineOperator"]}</div>
                                                <img id="caasinput_imgAddProfile" src={search}></img>
                                            </div>
                                            {this.state.lineOperatordropdown && (
                                                <div class="caaad08" >
                                                    <div class="caadropdowncard" ref={this.container} >
                                                        {(this.state.lineOperatordataTemporary?.map((name, index) => {
                                                            return (
                                                                <DropDownTable onClick={(index1) => this.changelineOperator(index1)} >
                                                                    <small class="pl-3" id="caatt2" >{name?.name} </small>
                                                                </DropDownTable>
                                                            );
                                                        }))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div class="caadivup5">
                                        <div class="caadivup3CreateAppointment">
                                            <small id="caaname">Truck License No. (Optional)</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    class="input" placeholder="Enter Truck License No."
                                                    type="text" id="caad06" value={this.state.truckLicenseNo}
                                                    onChange={this.handleChangeTruckLicenseNo}
                                                />
                                            </div>
                                        </div>
                                        <div class="caadivup3CreateAppointment">
                                            <small id="caaname">Reference No. (Optional)</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    class="input" placeholder="Enter Reference No."
                                                    type="text" id="caad06" value={this.state.referenceNo}
                                                    onChange={this.handleChangeReferenceNo}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="caadivup5">
                                        <div class="caadivup3CreateAppointment">
                                            <small id="caaname">Transaction Type</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="transactionvalue"
                                                    readOnly class="input" placeholder="Select Transaction Type"
                                                    type="text" id="caad066" value={this.state.transactionvalue}
                                                />
                                                <div className="createappointmenterror1">{this.state.errors["transactionType"]}</div>
                                                <i id="caainput_imgAddProfile" onClick={this.toggleDropdowntransaction}>{transactiondropdownImage}</i>
                                            </div>
                                            {this.state.transactiondropdown && (
                                                <div class="caaad08" >
                                                    <div class="caadropdowncard" ref={this.container} >
                                                        {(this.transaction?.map((name, index) => {
                                                            return (
                                                                <DropDownTable onClick={(index1) => this.changeRoleTypetransaction(index1)}>
                                                                    <small class="pl-3" id="caatt2" >{name?.name} </small>
                                                                </DropDownTable>
                                                            );
                                                        }))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div class="caadivup3CreateAppointment">
                                            <small id="caaname">Trucking Company</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="truckingCompany"
                                                    class="input" placeholder="Enter Trucking Company"
                                                    type="text" id="caad06" value={this.state.truckingCompany}
                                                    onChange={this.handleChangeTruckingCompany}
                                                    onKeyPress={this.toggleSearchtruckingcompanydrop}
                                                />
                                                <div className="createappointmenterror1">{this.state.errors["truckingCompany"]}</div>
                                                <img id="caasinput_imgAddProfile" src={search}></img>
                                            </div>
                                            {this.state.truckingcompanydropdown && (
                                                <div class="caaad08" >
                                                    <div class="caadropdowncard" ref={this.container} >
                                                        {(this.state.truckingcompanydata1?.map((name, index) => {
                                                            return (
                                                                <DropDownTable onClick={(index1) => this.changetruckingcompany(index1)} >
                                                                    <small class="pl-3" id="caatt2" >{name?.name} </small>
                                                                </DropDownTable>
                                                            );
                                                        }))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div class="caadivup5">
                                        <div class="caadivup3CreateAppointment">
                                            <small id="caaname">Driver License (Optional)</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    class="input" placeholder="Enter Driver License"
                                                    type="text" id="caad06" value={this.state.driverLicense}
                                                    onChange={this.handleChangeDriverLicense}
                                                    onKeyPress={this.toggleSearchdrivinglicensedrop}
                                                />
                                                <img id="caasinput_imgAddProfile" src={search}></img>
                                            </div>
                                            {this.state.drivinglicensedropdown && (
                                                <div class="caaad08" >
                                                    <div class="caadropdowncard" ref={this.container} >
                                                        {(this.state.driverlicensedata1?.map((name, index) => {
                                                            return (
                                                                <DropDownTable onClick={(index1) => this.changedrivinglicense(index1)} >
                                                                    <small class="pl-3" id="caatt2" >{name?.name} </small>
                                                                </DropDownTable>
                                                            );
                                                        }))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="caaoncsdivlow122CreateAppointment">
                                <div class="adscsdivlow2">
                                    Unit Information</div>
                            </div>
                            <div class="caadivup1">
                                <div class="caadivup4CreateAppointment">
                                    <div class="caadivup55">
                                        <div class="caadivup3CreateAppointment">
                                            <small id="caaname">Container ID</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="containerID"
                                                    class="input" placeholder="Enter Container ID"
                                                    type="text" id="caad06" value={this.state.containerID}
                                                    onChange={this.handleChangeContainerID}
                                                    onKeyPress={this.toggleSearchcontaineriddrop}
                                                />
                                                <div className="createappointmenterror1">{this.state.errors["containerID"]}</div>
                                                <img id="caasinput_imgAddProfile" src={search}></img>
                                            </div>
                                            {this.state.containeriddropdown && (
                                                <div class="caaad08" >
                                                    <div class="caadropdowncard" ref={this.container} >
                                                        {(this.state.containeriddata1?.map((name, index) => {
                                                            return (
                                                                <DropDownTable onClick={(index1) => this.changecontainerid(index1)} >
                                                                    <small class="pl-3" id="caatt2" >{name?.name} </small>
                                                                </DropDownTable>
                                                            );
                                                        }))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div class="caadivup3CreateAppointment">
                                            <small id="caaname">Container Equipment Type</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="containervalue"
                                                    readOnly class="input" placeholder="Select Container Equipment Type"
                                                    type="text" id="caad066" value={this.state.containervalue}
                                                />
                                                <div className="createappointmenterror1">{this.state.errors["containerEquipment"]}</div>
                                                <i id="caainput_imgAddProfile" onClick={this.toggleDropdowncontainer}>{containerdropdownImage}</i>
                                            </div>
                                            {this.state.containerdropdown && (
                                                <div class="caaad08" >
                                                    <div class="caadropdowncard" ref={this.container} >
                                                        {(this.containerData?.map((name, index) => {
                                                            return (
                                                                <DropDownTable onClick={(index1) => this.changeRoleTypecontainer(index1)} >
                                                                    <small class="pl-3" id="caatt2" >{name?.name} </small>
                                                                </DropDownTable>
                                                            );
                                                        }))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div class="caadivup5">
                                        <div class="caadivup3CreateAppointment">
                                            <small id="caaname">Booking No. (Optional in case of import)</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    class="input" placeholder="Enter Booking No."
                                                    type="text" id="caad06" value={this.state.bookingNo}
                                                    onChange={this.handleChangeBookingNo}
                                                />
                                            </div>
                                        </div>
                                        <div class="caadivup3CreateAppointment">
                                            <small id="caaname">Vessel Visit</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="vesselVisit"
                                                    class="input" placeholder="Enter Vessel Visit"
                                                    type="text" id="caad06" value={this.state.vesselVisit}
                                                    onChange={this.handleChangeVesselVisit}
                                                    onKeyPress={this.toggleSearchvesselvisitdrop}
                                                />
                                                <div className="createappointmenterror1">{this.state.errors["vesselVisit"]}</div>
                                                <img id="caasinput_imgAddProfile" src={search}></img>
                                            </div>
                                            {this.state.vesselvisitdropdown && (
                                                <div class="caaad08" >
                                                    <div class="caadropdowncard" ref={this.container} >
                                                        {(this.state.vesselvisitdata1?.map((name, index) => {
                                                            return (
                                                                <DropDownTable onClick={(index1) => this.changevesselvisit(index1)} >
                                                                    <small class="pl-3" id="caatt2" >{name?.name} </small>
                                                                </DropDownTable>
                                                            );
                                                        }))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="caaoncsdivlow122CreateAppointment">
                                <div class="adscsdivlow2">
                                    Appointment Time</div>
                            </div>
                            <div class="caadivup1">
                                <div class="caadivup4CreateAppointment">
                                    <div class="caadivup55">
                                        <div class="caadivup3CreateAppointment">
                                            <small id="caaname">Requested Date</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="requestedDate"
                                                    readOnly class="input" placeholder="Select Date"
                                                    type="text" id="caad06" value={this.state.showCalender ? calendarFormatted_date : null}
                                                />
                                                <div>
                                                    <div class="CreateAppointmentDateCalender">  {this.state.showCalender ? <div ref={this.container}> <Calendar onChange={this.handleMonthChanged} value={this.calender} /></div> : null}</div>
                                                </div><img id="caasinput_imgAddProfile" src={calender} onClick={this.toggleMonthCalendar}></img>
                                            </div>
                                            <div className="createappointmenterror1">{this.state.errors["requestedDate"]}</div>
                                        </div>
                                        <div class="caadivup3CreateAppointment">
                                            <small id="caaname">Appointment Openings</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="appointmentvalue"
                                                    readOnly class="input" placeholder="Select Appointment Openings"
                                                    type="text" id="caad066" value={this.state.appointmentvalue}
                                                />
                                                <div className="createappointmenterror1">{this.state.errors["appointmentOpenings"]}</div>
                                                <i id="caainput_imgAddProfile" onClick={this.toggleDropdownappointment}>{appointmentdropdownImage}</i>
                                            </div>
                                            {this.state.appointmentdropdown && (
                                                <div class="caaad08" >
                                                    <div class="caadropdowncard" ref={this.container} >
                                                        {(this.appointment?.map((name, index) => {
                                                            return (
                                                                <DropDownTable onClick={(index1) => this.changeRoleTypeappointment(index1)}  >
                                                                    <small class="pl-3" id="caatt2" >{name?.name} </small>
                                                                </DropDownTable>
                                                            );
                                                        }))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div class="caabuttdiv">
                                <Button class="caabuttdiv1" onClick={this.handleSubmit}>
                                    <small class="caabuttdiv2" >Submit</small>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="appcaanotifooter01">
                    <Footer />
                </div>
                <div class="appcaanotifooter02">
                    <Footer2 />
                </div>
                <SuccessModal hasOpen={this.state.hasOpen} onCloseModal={this.onCloseModal}>
                    <div>
                        <div class="successtext1outer">
                            <small class="successtext1">The appointment has been created successfully</small>
                        </div>
                        <div class="successtext2outer">
                            <small class="successtext2">Please remember the number for this appointment</small>
                        </div>
                        <div class="successtext3outer">
                            <small class="successtext3">Appointment number: 25935819</small>
                        </div>
                    </div>
                </SuccessModal>
                <ReasonsModal hasOpen={this.state.hasOpenPreview} onCloseModal={this.onCloseModalPreveiw} onClickModal={this.onClickModalPreview}>
                    <div className="modalHeadingreason">
                        <p className="modalHeadingTextTruckApp">The create operations have failed the following reasons</p>
                    </div>
                    <div className="sectionContainerreason">
                        <img src={hrLine} alt="Horizontal Dotted Line" className="successlineStyle" />
                        <div className="modalInnerContentTruckApp">
                            <small className="stepsDetailTruckApp">
                                Delivery not allowed before 11-Oct-2020 00:00 SAST for vessel visit DCT4465
                                         </small>
                        </div>
                        <img src={hrLine} alt="Horizontal Dotted Line" className="successlineStyle" />
                        <div className="modalInnerContentTruckApp">
                            <small className="stepsDetailTruckApp">
                                PCIU1750490 is past STORAGE LAST FREE DAY 30-Sep-2020 00:00 SAST
                                         </small>
                        </div>
                        <img src={hrLine} alt="Horizontal Dotted Line" className="successlineStyle" />
                        <div className="modalInnerContentTruckApp">
                            <small className="stepsDetailTruckApp">
                                Trucking company must be assigned to unit for deliveries
                                         </small>
                        </div>
                        <img src={hrLine} alt="Horizontal Dotted Line" className="successlineStyle" />
                        <div className="modalInnerContentTruckAppfourth">
                            <small className="stepsDetailTruckApp">Event type Ã¢â‚¬ËœUNIT_DELIVERÃ¢â‚¬â„¢ can not be applied to </small>
                            <small className="stepsDetailTruckApp">Ã¢â‚¬ËœUNIT: PCUIU1750490Ã¢â‚¬â„¢. Hold CUSTOMS HLD existis on </small>
                            <small className="stepsDetailTruckApp">Ã¢â‚¬ËœUNIT: PCUIU1750490Ã¢â‚¬â„¢</small>
                        </div>
                        <img src={hrLine} alt="Horizontal Dotted Line" className="successlineStyle" />
                        <div className="modalInnerContentTruckApp">
                            <small className="stepsDetailTruckApp">
                                Appointment should be for zone 202
                                         </small>
                        </div>
                        <img src={hrLine} alt="Horizontal Dotted Line" className="successlineStyle" />
                    </div>
                </ReasonsModal>
            </div>
        );
    }
}

export default CreateAppointment;